import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-claim-confirm',
  templateUrl: './modal-claim-confirm.component.html',
  styleUrls: ['./modal-claim-confirm.component.scss']
})
export class ModalClaimConfirmComponent implements OnDestroy {
   @Output() confirm: EventEmitter<object> = new EventEmitter();
  constructor(public modal: ModalService) {  }

    ngOnDestroy() {
      this.modal.close();
    }

    accept() {
      this.modal.close();
      this.confirm.emit();
    }
  }
